import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff, RefreshCw } from 'lucide-react';
import * as Sentry from '@sentry/react';

const ConnectionStatus = () => {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      Sentry.addBreadcrumb({
        category: 'connectivity',
        message: 'Connection lost',
        level: 'warning',
      });
      setIsOffline(true);
      setIsReconnecting(false);
    };
    const handleOnline = () => {
      Sentry.addBreadcrumb({
        category: 'connectivity',
        message: 'Connection restored',
        level: 'info',
      });
      setIsReconnecting(true);
      setTimeout(() => { setIsOffline(false); setIsReconnecting(false); }, 1500);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline && !isReconnecting) return null;

  return (
    <div className={`fixed top-0 start-0 end-0 z-[100] flex items-center justify-center gap-2 py-2 px-4 text-sm font-medium transition-all ${
      isReconnecting ? 'bg-success/90 text-white' : 'bg-amber-500/90 text-white'
    }`}>
      {isReconnecting ? (
        <><RefreshCw className="h-4 w-4 animate-spin" />{t('connection.reconnecting')}</>
      ) : (
        <><WifiOff className="h-4 w-4" />{t('connection.offline')}</>
      )}
    </div>
  );
};

export default ConnectionStatus;
